import React from "react";
import { AvailableRoom } from "../../../../api/grpc/workplaces/workplaces";
import { BookingsSearchHeader } from "../BookingsSearchHeader/BookingsSearchHeader";
import { BookingsRoomsTable } from "./BookingsRoomsTable";

interface Props {
  rooms: AvailableRoom[] | null;
}

export const BookingsRoomsResult = ({ rooms }: Props) => {
  return (
    <>
      {rooms && rooms?.length > 0 ? (
        <div>
          <BookingsSearchHeader type="room" />
          <BookingsRoomsTable rooms={rooms} />
        </div>
      ) : (
        <div>No results...</div>
      )}
    </>
  );
};
